import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: () => import('../views/ResetPassword.vue'),
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('../views/ForgotPassword.vue'),
    },
    {
      path: '/',
      name: 'root',
      redirect: '/home',
      component: () => import('../MainLayout.vue'),
      meta: {
        title: 'Ibback',
      },
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('../views/Home/HomeView.vue'),
          meta: {
            title: 'Ibback',
          },
        },
        {
          path: 'utilisateurs',
          name: 'Utilisateurs',
          component: () => import('../views/UsersView.vue'),
          meta: {
            title: 'Utilisateurs',
          },
        },
        {
          path: 'integration',
          name: 'Integration',
          meta: {
            title: 'Intégration',
          },
          children: [
            {
              path: 'integrate',
              name: 'Integrate',
              component: () => import('../views/Integration/IntegrationView.vue'),
            },
            {
              path: 'history',
              name: 'History',
              component: () => import('../views/Integration/IntegrationHistoryView.vue'),
            },
          ],
        },
        {
          path: 'lead/:uuid',
          meta: {
            title: 'Fiche du lead',
          },
          children: [
            {
              path: '',
              name: 'Lead',
              component: () => import('../views/Lead/LeadView.vue'),
            },
            {
              path: 'appointment',
              name: 'LeadAppointment',
              component: () => import('../views/Lead/LeadAppointmentView.vue'),
            },
          ],
        },
        {
          path: 'activity',
          meta: {
            title: 'Activité',
          },
          children: [
            {
              path: '',
              name: 'Activity',
              component: () => import('../views/Activity/ActivityView.vue'),
            },
            {
              path: 'stats-teleops',
              name: 'StatsTeleops',
              component: () => import('../views/Activity/Dashboard/OperatorsStatisticsView.vue'),
            },
            {
              path: 'teleops-timeline',
              name: 'TeleopsTimeline',
              component: () => import('../views/Activity/Timeline/TeleopsTimelineView.vue'),
            },
            {
              path: 'gamification',
              name: 'Gamification',
              component: () => import('../views/Activity/Gamification/GamificationView.vue'),
            },
            {
              path: 'leaderboard',
              name: 'Leaderboard',
              component: () => import('../views/Activity/Leaderboard/Leaderboard.vue'),
              meta: {
                fullscreen: true,
              },
            },
            {
              path: 'leads-follow-up',
              name: 'LeadsFollowUp',
              component: () => import('../views/Activity/LeadsFollowUp/LeadsFollowUp.vue'),
            },
            {
              path: 'availabilities',
              name: 'Availabilities',
              component: () => import('../views/Activity/Availabilities/AvailabilitiesView.vue'),
            },
          ],
        },
        {
          path: 'backoffice',
          name: 'Backoffice',
          children: [
            {
              path: 'configuration',
              name: 'Configuration',
              component: () => import('../views/BackOffice/Configuration/ConfigurationView.vue'),
              meta: {
                title: 'BO - Configuration',
              },
            },
            {
              path: 'missions',
              name: 'Missions',
              component: () => import('../views/BackOffice/Missions/MissionsView.vue'),
              meta: {
                title: 'BO - Missions',
              },
            },
            {
              path: 'marches',
              name: 'Markets',
              component: () => import('../views/BackOffice/Markets/MarketsView.vue'),
              meta: {
                title: 'BO - Marchés',
              },
            },
            {
              path: 'tags',
              name: 'Tags',
              component: () => import('../views/BackOffice/Tags/TagsView.vue'),
              meta: {
                title: 'BO - Tags',
              },
            },
            {
              path: 'sms',
              name: 'SMS',
              component: () => import('../views/BackOffice/Sms/SmsView.vue'),
              meta: {
                title: 'BO - SMS',
              },
            },
            {
              path: 'call-process',
              name: 'CallProcesses',
              component: () => import('../views/BackOffice/CallProcess/CallProcessesView.vue'),
              meta: {
                title: 'BO - Call process',
              },
              children: [
                {
                  path: '',
                  name: 'CallProcessesList',
                  component: () => import('../views/BackOffice/CallProcess/CallProcessesList.vue'),
                },
                {
                  path: ':callProcessId',
                  name: 'CallProcess',
                  component: () => import('../views/BackOffice/CallProcess/CallProcessView.vue'),
                },
              ],
            },
            {
              path: 'mails',
              name: 'Mails',
              component: () => import('../views/BackOffice/Mails/MailsView.vue'),
              meta: {
                title: 'BO - Mails',
              },
            },
            {
              path: 'crons',
              name: 'Crons',
              component: () => import('../views/CronJob/cronJobView.vue'),
            },
            {
              path: 'teams',
              name: 'Teams',
              component: () => import('../views/BackOffice/Teams/TeamsView.vue'),
              meta: {
                title: 'BO - Équipes',
              },
            },
            {
              path: 'aircall-webhooks-status',
              name: 'AircallWebhooksStatus',
              component: () => import('../views/BackOffice/AircallWebhook/AircallWebhooksStatus.vue'),
              meta: {
                title: 'Aircall Webhooks Status',
              },
            },
            {
              path: 'leads-transfer',
              name: 'LeadsTransfer',
              component: () => import('../views/BackOffice/LeadsTransfer/LeadsTransferView.vue'),
            },
          ],
        },
        {
          path: 'affectations',
          name: 'Affectations',
          children: [
            {
              path: 'missions',
              name: 'MissionsAffectation',
              component: () => import('../views/Affectation/MissionsAffectationView.vue'),
            },
            {
              path: 'mission/:missionId',
              name: 'UsersMission',
              component: () => import('../views/Affectation/UsersView.vue'),
            },
            {
              path: 'teams',
              name: 'TeamsAffectation',
              component: () => import('../views/Affectation/TeamAffectationView.vue'),
            },
          ],
        },
        {
          path: 'extractions',
          name: 'Extractions',
          component: () => import('../views/Extractions/LeadsExtractionView.vue'),
        },
        {
          path: 'dev',
          name: 'Dev',
          meta: {
            title: 'Dev',
          },
          children: [
            {
              path: 'call-center-activity',
              name: 'CallCenterActivity',
              component: () => import('../views/Dev/CallCenterActivity.vue'),
            },
            {
              path: 'monitor',
              name: 'Monitor',
              component: () => import('../views/Dev/MonitorView.vue'),
              meta: {
                title: 'Monitor',
              },
            },
            {
              path: 'utilities',
              name: 'Utilities',
              component: () => import('../views/Dev/UtilitiesView.vue'),
              meta: {
                title: 'Utilitaires',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/404.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    },
  ],
})

export default router
